import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative h-[200svh] lg:h-auto',
    screen: 'sticky top-0 h-[100svh] lg:static lg:h-auto',
    bg: 'absolute inset-0 h-full w-full object-cover lg:static lg:h-auto lg:max-h-[740px] lg:min-h-[740px]',
    content:
      'absolute top-[76px] right-0 left-0 text-center md:top-[120px] lg:top-[135px] lg:-translate-y-0',
    text: 'mx-3 mb-5 [font-family:var(--font-source-serif-4)] text-[24px] leading-[1.1] font-normal lg:max-w-[338px] lg:text-left lg:text-[30px] lg:leading-[1.15]',
    title:
      'mb-6 text-[16px] leading-[1.2] font-light tracking-[0.2em] uppercase transition-all duration-500 lg:mb-3 lg:text-[20px]',
    semibold: 'font-semibold',
    italic: 'mt-1 text-[24px] italic lg:text-[31.5px]',
    info: 'mb-6 transition-all duration-500 lg:absolute lg:top-1/2 lg:left-[calc(50%+290px)] lg:-translate-y-1/2 lg:pt-[408px] lg:text-left',
    textWrapper:
      'transition-all duration-500 lg:absolute lg:top-1/2 lg:right-[calc(50%+270px)] lg:-translate-y-1/2 lg:pt-[395px]',
    infoText:
      'mb-4 text-[18px] leading-[1.3] font-bold tracking-[0.2em] text-[#24233D] uppercase',
    infoTextMobile:
      'mb-4 block text-[14px] leading-[1.3] font-bold tracking-[0.2em] text-[#24233D] uppercase lg:hidden',
    infoNumber:
      'mb-3 [font-family:var(--font-source-serif-4)] text-[110px] leading-[.8] lg:mb-2 lg:text-[128px]',
    number: 'font-light',
    infoDescription: 'text-[20px] leading-[1] font-normal lg:leading-[1.3]',
    small: 'text-[68px] xl:text-[80px]',
    arrowDown: 'absolute right-0 bottom-18 left-0 text-black lg:bottom-15'
  }
});
